







import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        showCancelButton: {
            type: Boolean,
            default: true
        },
        showOkButton: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    mounted() {
        let $el: HTMLDialogElement = this.$el  as HTMLDialogElement
        $el.showModal()
    }
})

